import React from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import history from '../../history';
import { Nav, NavItem, NavLink, Col, Container, Row, Card, CardBody, Button, ButtonToolbar, Table, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import ArticlesForm from './Articles/components/ArticlesForm';

const Inventory = () => {

    const [activeTab, setActiveTab] = React.useState('1');

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title">Inventario</h3>
                    <br />
                </Col>
            </Row>

            <Card>
                <CardBody>
                    <div className="tabs tabs--justify tabs--bordered-top">
                        <div className="tabs__wrap">
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === '1' })}
                                        onClick={() => toggle('1')}
                                    >
                                        Inventario
                                    </NavLink>
                                </NavItem>
                                {
                                    /**
                                     * 
                                     * 
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === '2' })}
                                        onClick={() => toggle('2')}
                                    >
                                        Tipos de Inventario
                                    </NavLink>
                                </NavItem>
                                     * 
                                     */
                                }
                            </Nav>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    <div className="text-center">
                                        <ArticlesForm />
                                    </div>
                                </TabPane>
                                <TabPane tabId="2">
                                    <div className="text-center">

                                    </div>
                                </TabPane>
                            </TabContent>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Container>
    );


}
export default Inventory;
